import { useEffect } from "react";
import { breadCrumbsState } from "../../../../store/layout";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";

interface IUseDomainBreadcrumbsProps {
	global: {
		id: string;
		name: string;
	};
	product: {
		id: string;
		name: string;
	};
	childDomainName: string;
}

export const useDomainBreadcrumbs = (props: IUseDomainBreadcrumbsProps) => {
	const [, setBreadCrumbs] = useRecoilState(breadCrumbsState);
	const { t } = useTranslation();

	useEffect(() => {
		const links = [
			{
				label: t("organization-settings"),
				link: "/organization-settings",
			},
			{
				label: t("organization-settings-tab-domains"),
				link: "/organization-settings/domains",
			},
			{
				label: props.global.name,
				link: `/organization-settings/domains/${props.global.id}`,
			},
			{
				label: props.product.name,
				link: `/organization-settings/domains/${props.product.id}`,
			},
			{
				label: props.childDomainName,
				link: undefined,
			},
		].filter((link) => !!link.label);
		setBreadCrumbs({
			fromProps: true,
			links: links,
		});
		return () => setBreadCrumbs(null);
	}, [props.childDomainName, props.global.name, props.global.id, props.product.name, props.product.id]);
};
